// @flow
import React from "react";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import DateRangeIcon from "@material-ui/icons/DateRange";
import HelpIcon from "@material-ui/icons/Help";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { useLocation, useHistory } from "react-router-dom";
import TableChartIcon from '@material-ui/icons/TableChart';

const MAIN_TABS = [
  {
    path: "/",
    label: "Spiele",
    icon: <DateRangeIcon />,
  },
  {
    path: "/rankings",
    label: "Tabelle",
    icon: <TableChartIcon />,
  },
  {
    path: "/profile",
    label: "Profil",
    icon: <AccountBoxIcon />,
  },
  {
    path: "/help",
    label: "Hilfe",
    icon: <HelpIcon />,
  },
];

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      borderTopWidth: 1,
      borderTopStyle: "solid",
      zIndex: 1105,
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
    },
  })
);

function MainTabNavigation() {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();

  if (
    location != null &&
    location.pathname != null &&
    (
      location.pathname.startsWith("/ticket-reservation") ||
      location.pathname.startsWith("/ticker")
    )
  ) {
    return null;
  }

  const usePaperBackground =
    location != null &&
    location.pathname != null &&
    location.pathname.startsWith("/ticket");

  return (
    <>
      <div
        style={{ height: "calc(80px + env(safe-area-inset-bottom)" }}
        className={usePaperBackground ? classes.paper : classes.default}
      />
      <BottomNavigation
        value={location != null ? location.pathname : "/"}
        onChange={(event, newValue) => {
          history.push(newValue);
        }}
        showLabels
        component={"nav"}
        className={classes.root}
      >
        {MAIN_TABS.map(({ label, icon, path }) => (
          <BottomNavigationAction
            key={label}
            label={label}
            icon={icon}
            value={path}
          />
        ))}
      </BottomNavigation>
    </>
  );
}

export default MainTabNavigation;
